module.exports = "/_next/static/images/535d7cb478114a70ad67685f5dea3889-girl-holding-phone@3x.jpg";